import {
  getStafferTimeAndAttendanceStatsRetrieveQueryOptions,
  type ForManagerLocationDetail,
} from "@sidegigllc/api/client";
import { startOfMinute } from "date-fns";
import {
  buildTimeAndAttendanceScope,
  type LocationViewContext,
  withActiveShiftWindow,
} from "domains/gigs/containers/MultiShiftTimeAndAttendance/timeAndAttendanceScope";
import type { WarmableQuery } from "routing/warmQueries";
import { suspenseQuery } from "utils/suspenseQuery";

type QueriesInput = { location: ForManagerLocationDetail; now: Date };

export const viewContext = (location: ForManagerLocationDetail): LocationViewContext => ({
  type: "location",
  locationId: location.id,
  mine: true,
});

export const inProgressStatsQuery = ({ location, now }: QueriesInput) =>
  suspenseQuery(
    getStafferTimeAndAttendanceStatsRetrieveQueryOptions(
      withActiveShiftWindow(buildTimeAndAttendanceScope(viewContext(location)), startOfMinute(now)),
    ),
  );

export const queries = (input: QueriesInput): Array<WarmableQuery> => [inProgressStatsQuery(input)];
